const EVENT_TYPES = {
  UPLOADER_READY: 'UPLOADER_READY',
  UPLOADER_FILE_STATUS: 'UPLOADER_FILE_STATUS',
  UPLOADER_SHOW: 'UPLOADER_SHOW',
  UPLOADER_UPDATE_SETTINGS: 'UPLOADER_UPDATE_SETTINGS',
  UPLOADER_CLIENT_HIDE: 'UPLOADER_CLIENT_HIDE',
  UPLOADER_CLIENT_TAGS: 'UPLOADER_CLIENT_TAGS',
  UPLOADER_CLIENT_UPLOAD_PRESETS: 'UPLOADER_CLIENT_UPLOAD_PRESETS',
  UPLOADER_CLIENT_MINIMIZE: 'UPLOADER_CLIENT_MINIMIZE',
  UPLOADER_BATCH_STARTED: 'UPLOADER_BATCH_STARTED',
  UPLOADER_CROP_STARTED: 'UPLOADER_CROP_STARTED',
  UPLOADER_BATCH_CANCELLED: 'UPLOADER_BATCH_CANCELLED',
  UPLOADER_CLOUD_INFO: 'UPLOADER_CLOUD_INFO',
  UPLOADER_SUCCESS_COUNTER: 'UPLOADER_SUCCESS_COUNTER',
  UPLOADER_MD_STARTED: 'UPLOADER_MD_STARTED',
};

export { EVENT_TYPES };
